module.exports = __webpack_public_path__ + "static/media/ceget-kepviselek.e39a9b0c.png";